import { render, staticRenderFns } from "./BecomeAVendor.vue?vue&type=template&id=c34d2f4a"
import script from "./BecomeAVendor.vue?vue&type=script&lang=js"
export * from "./BecomeAVendor.vue?vue&type=script&lang=js"
import style0 from "./BecomeAVendor.vue?vue&type=style&index=0&id=c34d2f4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports